import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '~/providers/user';
const Home = () => {
    const { useNewView } = useUser();
    return useNewView
        ? React.createElement(Navigate, { to: '/content-library', replace: true })
        : React.createElement(Navigate, { to: '/recent-activity', replace: true });
};
export default Home;
